import { render, staticRenderFns } from "./AnnouncementsLandingPage.vue?vue&type=template&id=f474ec78&scoped=true"
import script from "./AnnouncementsLandingPage.vue?vue&type=script&lang=js"
export * from "./AnnouncementsLandingPage.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementsLandingPage.vue?vue&type=style&index=0&id=f474ec78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f474ec78",
  null
  
)

export default component.exports